module.exports = __webpack_public_path__ + "static/media/VerifyEmail.3e6d8912.svg";